import HttpService from "./htttp.service";

class AuditsServices {
  getAudits = async (payload, cancelToken) => {
    const endpoint = "audits";
    if (!payload) payload = {};
    payload.dontIncludeKpis = true;
    return await HttpService.get(endpoint, payload, cancelToken);
  };

  auditHasTasks = async (id) => {
    const endpoint = `audits/${id}/hasTasks`;
    return await HttpService.get(endpoint);
  };

  getStatuses = async (payload, cancelToken) => {
    const endpoint = "audits/statuses";
    return await HttpService.get(endpoint, payload, cancelToken);
  };

  getAudit = async (query, cancelToken) => {
    const endpoint = "audits/" + query;
    return await HttpService.get(endpoint, query, cancelToken);
  };

  getAuditCore = async (id, cancelToken) => {
    return HttpService.get(`audits/${id}`, { deferBranchData: true }, cancelToken);
  };

  getAuditBranchData = async (id, cancelToken) => {
    return HttpService.get(`audits/${id}/branch-data`, undefined, cancelToken);
  };

  updateAudit = async (query, payload) => {
    const endpoint = "audits/" + query;
    return await HttpService.put(endpoint, payload);
  };

  updateAuditStatus = async (query, payload) => {
    const endpoint = "audits/" + query + "/status";
    return await HttpService.put(endpoint, payload);
  };

  updateAuditsStatus = async (payload) => {
    const endpoint = "audits/status";
    return await HttpService.put(endpoint, payload);
  };

  updateAuditFirstAnsweredAt = async (query, payload) => {
    const endpoint = "audits/" + query + "/site-in";
    return await HttpService.put(endpoint, payload);
  };

  updateKpi = async (query, payload) => {
    const endpoint = "audits/kpis/" + query;
    return await HttpService.put(endpoint, payload);
  };

  updateAuditKpis = async (query, payload) => {
    const endpoint = `audits/${query}/kpis`;
    return await HttpService.uploadFilesWithData(
      endpoint,
      payload.files,
      payload.body,
      "post",
    );
  };

  updateAuditBaseKpis = async (id, payload) => {
    const endpoint = `audits/${id}/kpis/base`;
    return await HttpService.put(endpoint, payload);
  };

  createAudit = async (payload) => {
    const endpoint = "audits";
    return await HttpService.post(endpoint, payload);
  };

  removeAudit = async (payload) => {
    const endpoint = "audits/" + payload;
    return await HttpService.delete(endpoint, payload);
  };

  removeBranchGroup = async (payload) => {
    const endpoint = "branches/groups/" + payload;
    return await HttpService.delete(endpoint, payload);
  };

  generateReport = async (id) => {
    const endpoint = `audits/${id}/report/assessment`;
    return await HttpService.post(endpoint);
  };

  generateAssessmentReportLink = async (id, query, payload) => {
    const endpoint = `audits/${id}/report/assessment/link`;
    return await HttpService.post(endpoint, payload, query);
  };

  generateAssessmentReportPreview = async (id, query, payload) => {
    const endpoint = `audits/${id}/report/assessment/link`;
    return await HttpService.postText(endpoint, payload, query);
  };

  getConsolidatedReport = async (id) => {
    const endpoint = `audits/${id}/report/consolidated`;
    return await HttpService.get(endpoint);
  };

  upsertConsolidatedReport = async (id, data) => {
    const endpoint = `audits/${id}/report/consolidated`;
    return await HttpService.post(endpoint, data);
  };

  getAssessmentReportsDataForConsolidated = async (auditIds) => {
    const endpoint = `audits/report/assessment`;
    return HttpService.post(endpoint, auditIds);
  };

  updateAttachement = async (auditId, auditKpiId, attachmentId, data) => {
    const endpoint = `audits/${auditId}/answers/${auditKpiId}/attachments/${attachmentId}`;
    return HttpService.put(endpoint, data);
  };

  getReportAttachments = async (id) => {
    const endpoint = `audits/${id}/report/assessment/attachments`;
    return await HttpService.get(endpoint);
  };

  updateReportAttachment = async (id, attachmentId, data) => {
    const endpoint = `audits/${id}/report/assessment/attachments/${attachmentId}`;
    return await HttpService.put(endpoint, data);
  };

  upsertAuditReceipt = async (id, data) => {
    const endpoint = `audits/${id}/receipt`;
    return await HttpService.put(endpoint, data);
  };

  updateAuditReceiptAttachment = async (id, files) => {
    const endpoint = `audits/${id}/receipt/attachment`;
    return await HttpService.uploadFilesWithData(endpoint, files, null, "put");
  };

  deleteAuditReceiptAttachment = async (id) => {
    const endpoint = `audits/${id}/receipt/attachment`;
    return await HttpService.delete(endpoint);
  };
}

export default new AuditsServices();
